import { CardSheet, type CardSheetConfig } from '../components/CardSheet';
import { reportsApi } from '../lib/reportsApi';

/**
 * Student ID cards.
 *
 * ⚠ THE SCREEN NOW LIVES IN components/CardSheet, matching the server where one renderer produces
 * both faces. Two screens would drift the day either was adjusted, and on this feature the
 * millimetres are the product.
 */
const config: CardSheetConfig = {
  eyebrow: 'Students',
  title: 'ID cards',
  intro: (
    <>
      Printed at exact card size — 85.6 × 54 mm, the size of every blank PVC card and lanyard
      holder. Print on card stock and cut along the marks, or feed blanks through a card printer.
    </>
  ),
  path: '/api/students/id-cards',
  groupParam: 'academicClassId',
  groupLabel: 'Class',
  // ⚠ A class IS required here, unlike staff: a 640-student school in one document is 50+ MB of
  // embedded photographs that a browser appears to hang on.
  groupRequired: true,
  loadGroups: async () => (await reportsApi.registerGroups('students'))
    .map((g) => ({ id: g.id, label: g.label, people: g.people })),
  emptyHint: (
    <>
      Choose a class and press <strong>Build the sheet</strong>. Students without a photograph still
      get a card, with a space to add one later.
    </>
  ),
};

export function IdCardsPage() {
  return <CardSheet config={config} />;
}
